import Tag from "components/Common/Tag/Tag";
import { useKeywordSuggester } from "hooks/useKeywordSuggester";
import React, { useEffect } from "react";
import starsicon from "../../images/stars.svg";
import CustomTagWithPlus from "components/Common/Tag/CustomTagWithPlus";
import { CloseOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useAppSelector } from "hooks/reduxHooks";
import { FaSync } from "react-icons/fa";
import { SvgIcons } from "Icon/SvgIcons";
const FaSyncSin = FaSync as unknown as React.FC as any;

interface KeywordSuggesterProps {
  jobTitles: string[];
  isSectionTitleRequired: boolean;
  sectionTitle?: string;
  handleAdd?: (value: string) => void;
  selectedValues?: string[];
  onClearAll?: () => void;
}

const KeywordSuggester: React.FC<KeywordSuggesterProps> = ({
  jobTitles,
  isSectionTitleRequired,
  sectionTitle,
  handleAdd,
  selectedValues = [], // Default to an empty array if not provided
  onClearAll,
}) => {
  const { keywords, loading, refreshLoading, error, fetchKeywords, refreshKeywords } =
    useKeywordSuggester();
  const selectedProject = useAppSelector((state: any) => state.search?.selectedProjectFromSearch);

  useEffect(() => {
    if (jobTitles.length > 0) {
      console.log("Job Title : ", jobTitles);
      fetchKeywords(jobTitles);
    } else {
      console.log("Job Title in project : ", selectedProject);
      fetchKeywords(selectedProject?.official_title);
    }
  }, [jobTitles]);

  return (
    <div className="mb-4">
      {isSectionTitleRequired ? (
        <h2 className="text-sm font-normal mb-2 flex gap-2 justify-start items-center text-text-quaternary">
          <img className="relative" src={starsicon} alt="Stars Icon" /> {sectionTitle}:
        </h2>
      ) : (
        ""
      )}
      <div className="flex flex-wrap gap-2">
        {loading ? (
          <Spin spinning={loading} size="small" />
        ) : error ? (
          // <p>Error: {error.message}</p>
          <></>
        ) : (
          <>
            {keywords?.map((keyword, index) => {
              const isSelected = selectedValues.includes(keyword);
              return (
                <React.Fragment key={index}>
                  <CustomTagWithPlus
                    value={keyword}
                    isSelected={isSelected}
                    handleClick={handleAdd}
                  />
                </React.Fragment>
              );
            })}
            {/* <button
          onClick={refreshKeywords} 
          className="flex items-center justify-center button-hover-effect text-sm"
          >
            {refreshLoading ? (
              <Spin spinning={refreshLoading} size="small" className="mr-1" />
            ) : (
              <>
                {keywords?.map((keyword, index) => {
                  const isSelected = selectedValues.includes(keyword);
                  return (
                    <React.Fragment key={index}>
                      <CustomTagWithPlus
                        value={keyword}
                        isSelected={isSelected}
                        handleClick={handleAdd}
                      />
                    </React.Fragment>
                  );
                })
                } */}
            <button
              onClick={refreshKeywords}
              className="flex items-center justify-center button-hover-effect text-xs 
                         font-medium text-text-secondary py-0.5 px-2 border bg-bg-secondary  border-main-border gap-1
                         rounded-md"
            >
              {refreshLoading ? (
                <Spin spinning={refreshLoading} size="small" />
              ) : (
                <>
                  {SvgIcons.primaryRefreshIcon}
                </>
              )}
              &nbsp;Refresh
            </button>
            {keywords && keywords?.length > 0 && (
              <button
                onClick={onClearAll}
                className="flex items-center justify-center
               py-0.5 px-2 border bg-red-50
               border-red-200 gap-2 rounded-md
              focus:outline-none focus:ring-none text-sm"
              >
                <Tag
                  title="Clear All"
                  prefixIcon={<CloseOutlined size={12} className="mr-1" style={{ color: "red" }} />}
                  tagType="secondary"
                  titleColor="text-red-500 hover:text-red-700"
                  className="transition 
                duration-300 ease-in-out text-xs font-medium"
                />
              </button>
            )}
          </>
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default KeywordSuggester;
